<template>
    <div>

        <!-- Aging Stock Start -->
        <div class="row">
            <div class="col-md-6">
                <span class="section--title">Aging Stock</span>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-6 col-md-3">
                        <Multiselect 
                            :options="options.agingStock.dealer.map(x => x.code)"
                            :custom-label="opt => options.agingStock.dealer.find(x => x.code == opt).name"
                            placeholder="All Dealer"
                            v-model="filter.agingStock.dealer" 
                        />
                    </div>
                    <div class="col-6 col-md-3">                        
                        <Multiselect 
                            :options="options.agingStock.segment.map(x => x.segment)"
                            placeholder="All Segment"
                            v-model="filter.agingStock.segment" 
                        />
                    </div>
                    <div class="col-6 col-md-3">                        
                        <Multiselect 
                            :options="options.agingStock.type.map(x => x.type)"
                            placeholder="All Type"
                            v-model="filter.agingStock.type" 
                        />
                    </div>
                    <div class="col-6 col-md-3">                        
                        <Multiselect 
                            :options="options.agingStock.color.map(x => x.color)"
                            :custom-label="opt => options.agingStock.color.find(x => x.color == opt).name"
                            placeholder="All Color"
                            v-model="filter.agingStock.color" 
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- Charts Start -->
        <div class="row">
            <div class="col-md-8">
                <aging-stock-bar-chart
                    :data="data.agingStock.data"
                ></aging-stock-bar-chart>
            </div>
            <div class="col-md-4">
                <aging-stock-pie-chart
                    :data="data.agingStock.data"
                ></aging-stock-pie-chart>
            </div>
        </div>
        <!-- Charts End -->

        <aging-stock-stats
            class="pt-4 pb-4"
            :data="data.agingStock.stats"
        ></aging-stock-stats>
        <!-- Aging Stock End -->

        <div class="dh--divider mt-0"></div>

        <!-- Detail Aging Stock Start -->
        <div class="row">
            <div class="col-md-6">
                <span class="section--title">Detail Aging Stock</span>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-6 col-md">
                        <Multiselect 
                            :options="options.agingStockDetails.dealer.map(x => x.code)"
                            :custom-label="opt => options.agingStockDetails.dealer.find(x => x.code == opt).name"
                            placeholder="All Dealer"
                            v-model="filter.agingStockDetails.dealer" 
                        />
                    </div>
                    <div class="col-6 col-md">                        
                        <Multiselect 
                            :options="options.agingStockDetails.segment.map(x => x.segment)"
                            placeholder="All Segment"
                            v-model="filter.agingStockDetails.segment" 
                        />
                    </div>
                    <div class="col-6 col-md">                        
                        <Multiselect 
                            :options="options.agingStockDetails.type.map(x => x.type)"
                            placeholder="All Type"
                            v-model="filter.agingStockDetails.type" 
                        />
                    </div>
                    <div class="col-6 col-md">                        
                        <Multiselect 
                            :options="options.agingStockDetails.color.map(x => x.color)"
                            :custom-label="opt => options.agingStockDetails.color.find(x => x.color == opt).name"
                            placeholder="All Color"
                            v-model="filter.agingStockDetails.color" 
                        />
                    </div>
                    <div class="col-6 col-md">
                        <button
                            class="btn btn-dh-download"
                            @click="downloadDetailAgingStock"
                            :disabled="downloadAgingLoading"
                        >Download CSV&nbsp;&nbsp;<i class="fas fa-download"></i></button>
                    </div>
                </div>
            </div>
        </div>

        <detail-aging-stock-table
            :data="data.agingStockDetails"
        ></detail-aging-stock-table>
        <!-- Detail Aging Stock End -->

    </div>
</template>

<script>
    import qs from 'qs'
    import moment from 'moment'
    import Multiselect from 'vue-multiselect'

    import agingStockBarChart from './charts/agingStockBarChart'
    import agingStockPieChart from './charts/agingStockPieChart'

    import agingStockStats from './children/agingStockStats'
    import detailAgingStockTable from './children/detailAgingStockTable'

    export default {
        data () {
            return {
                mobile : this.isMobile(),

                options : {
                    agingStock : {
                        segment : this.$store.getters.getSimpleSegment(),
                        type : this.$store.getters.getSimpleType(),
                        color : this.$store.getters.getColor,
                        dealer : this.$store.getters.getDealer()
                    },
                    agingStockDetails : {
                        segment : this.$store.getters.getSimpleSegment(),
                        type : this.$store.getters.getSimpleType(),
                        color : this.$store.getters.getColor,
                        dealer : this.$store.getters.getDealer()
                    }
                },
                selected : {
                    agingStockMain : {
                        segment : null,
                        type : null,
                        color : null
                    }
                },
            }
        },
        props : ['filter', 'data'],
        components : {
            Multiselect,

            agingStockBarChart,
            agingStockPieChart,

            agingStockStats,
            detailAgingStockTable,
        },
        mounted () {

        },
        computed : {
            agingStockSegment () {return this.filter.agingStock.segment},
            agingStockDetailsSegment () {return this.filter.agingStockDetails.segment}
        },
        watch : {
            "agingStockSegment" () {
                this.options.agingStock.type = this.$store.getters.getSimpleType(null, this.filter.agingStock.segment, null);
                this.filter.agingStock.type = null;
            },
            "agingStockDetailsSegment" () {
                this.options.agingStockDetails.type = this.$store.getters.getSimpleType(null, this.filter.agingStockDetails.segment, null);
                this.filter.agingStockDetails.type = null;
            },
        },
        methods : {
            async downloadDetailAgingStock () {
                //Set download loading to true, so it won't be re-clicked
                this.downloadAgingLoading = true;

                //Get the download type data
                await this.$http.get(`/api/highlight-dealer/aging-stock/details?download=1&${qs.stringify(this.filter.agingStockDetails, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then(async (resp)=>{
                    //Download the csv and set the date to the period
                    await this.exportCsv(resp.data.data, `Aging Stock Details (${moment(this.filter.agingStockDetails.period).format("DD MMM YYYY")})`);
                })
                .catch((err)=>{console.log(err)})
                .finally(()=>{
                    //Disabled the loading
                    this.downloadAgingLoading = false;
                });
            }
        }
    }
</script>

<style scoped>
    
</style>